import React from 'react';
import { useLanguage } from '../context/LanguageContext.jsx';

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="lang-switcher" role="group" aria-label="Sélection de la langue / اختيار اللغة">
      <button
        type="button"
        className={`lang-btn ${language === 'fr' ? 'active' : ''}`}
        onClick={() => setLanguage('fr')}
        aria-pressed={language === 'fr'}
      >
        Français
      </button>
      <button
        type="button"
        className={`lang-btn ${language === 'ar' ? 'active' : ''}`}
        onClick={() => setLanguage('ar')}
        aria-pressed={language === 'ar'}
      >
        العربية
      </button>
    </div>
  );
}
